/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GenericResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { ServizioMensaMenuDTO } from '../model/models';
import { ServizioMensaMenuUpsertForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CreateServizioMensaMenuRequestParams {
    gestioneMenseServizioId: string;
    menu: ServizioMensaMenuUpsertForm;
    file?: Blob;
}

export interface DeleteServizioMensaMenuRequestParams {
    idMenu: string;
    gestioneMenseServizioId: string;
}

export interface DownloadServizioMensaMenuRequestParams {
    idMenu: string;
    gestioneMenseServizioId: string;
}

export interface ListServizioMensaMenuRequestParams {
    gestioneMenseServizioId: string;
}

export interface UpdateServizioMensaMenuRequestParams {
    idMenu: string;
    gestioneMenseServizioId: string;
    menu: ServizioMensaMenuUpsertForm;
    file?: Blob;
}


export interface ServizioMensaMenuServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Crea un menu sul servizio mensa.
     * Crea un nuovo menu sul servizio risolto dall\&#39;header. Part JSON \&#39;menu\&#39; + part \&#39;file\&#39; (allegato caricato su S3). Ritorna la lista aggiornata dei menu del servizio.
     * @endpoint post /api/v1/servizi/mensa/menu
* @param requestParameters
     */
    createServizioMensaMenu(requestParameters: CreateServizioMensaMenuRequestParams, extraHttpRequestParams?: any): Observable<Array<ServizioMensaMenuDTO>>;

    /**
     * Elimina un menu del servizio mensa.
     * Elimina un menu EXTRA non associato ad alcuno studente. ORDINARIO non cancellabile.
     * @endpoint delete /api/v1/servizi/mensa/menu/{id_menu}
* @param requestParameters
     */
    deleteServizioMensaMenu(requestParameters: DeleteServizioMensaMenuRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Scarica il file di un menu del servizio mensa.
     * Scarica da S3 il file allegato al menu indicato. La chiave S3 è quella persistita sul menu (non un parametro): non è possibile scaricare un oggetto arbitrario.
     * @endpoint get /api/v1/servizi/mensa/menu/{id_menu}/download
* @param requestParameters
     */
    downloadServizioMensaMenu(requestParameters: DownloadServizioMensaMenuRequestParams, extraHttpRequestParams?: any): Observable<Blob>;

    /**
     * Lista dei menu del servizio mensa.
     * Ritorna tutti i menu (ORDINARIO ed EXTRA) del servizio risolto dall\&#39;header Gestione-Mense-Servizio-Id. Audience operatore.
     * @endpoint get /api/v1/servizi/mensa/menu
* @param requestParameters
     */
    listServizioMensaMenu(requestParameters: ListServizioMensaMenuRequestParams, extraHttpRequestParams?: any): Observable<Array<ServizioMensaMenuDTO>>;

    /**
     * Aggiorna un menu del servizio mensa.
     * Aggiorna tipo/identificativo e/o sostituisce il file di un menu del servizio. Applica i side-effect su promozione e rinomina. Ritorna la lista aggiornata.
     * @endpoint patch /api/v1/servizi/mensa/menu/{id_menu}
* @param requestParameters
     */
    updateServizioMensaMenu(requestParameters: UpdateServizioMensaMenuRequestParams, extraHttpRequestParams?: any): Observable<Array<ServizioMensaMenuDTO>>;

}
